import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import { OrderVideoMessage } from './model/ClientModels';

export const init = async () => {
  const response = await fetch('/__/firebase/init.json');
  if (!response.ok) {
    alert(response.statusText);
  }
  const json = await response.json();
  firebase.initializeApp(json);
};

export const createSiteSeller = async (payload: any) => {
  const create = await firebase
    .functions()
    .httpsCallable('site-createSiteSeller');
  return create(payload);
};

export const createSiteMarketing = async (payload: any) => {
  const create = await firebase
    .functions()
    .httpsCallable('site-createSiteMarketing');
  return create(payload);
};

export const submit = async (passcode: string) => {
  const verify = await firebase
    .functions()
    .httpsCallable('videoPasscode-verify');
  return verify({
    passcode,
  }).then(result => result.data);
};

export const fetchUser = async (id: string) => {
  const queryProfile = firebase
    .firestore()
    .collection('profiles')
    .doc(id)
    .get();
  const queryStore = firebase.firestore().collection('stores').doc(id).get();

  const queryListings = firebase
    .firestore()
    .collection(`stores/${id}/publicListings`)
    .orderBy('createdAt', 'desc')
    .limit(4)
    .get();

  return Promise.all([queryProfile, queryStore, queryListings]).then(result => {
    const profile = result[0].data();
    if (!profile) {
      return;
    }
    const { avatar, firstName, lastName } = profile;
    const userName = `${firstName || ''} ${lastName || ''}`;
    const listings = result[2].docs.map(doc => doc.data().defaultImage);
    const store = result[1].data();
    const storeFrontName = (store && store.name) || profile.storeFrontName;
    return {
      avatar,
      userName,
      storeFrontName,
      listings,
    };
  });
};

export const unsubscribe = async (userId: string) => {
  if (!userId) {
    return;
  }
  const unsubscribeEmail = firebase
    .functions()
    .httpsCallable('email-unsubscribe');
  return unsubscribeEmail({
    userId,
  });
};

export const getUpcomingShow = async (showID: string) => {
  const doc = await firebase
    .firestore()
    .collection('upcomingShows')
    .doc(showID)
    .get();
  return doc.data();
};

export const getVideoMessage = async (messageId: string) => {
  const doc = await firebase
    .firestore()
    .collection('messages')
    .doc(messageId)
    .get();
  return doc.data() as OrderVideoMessage;
};

export const createSellerMareting201905 = async (payload: any) => {
  payload.createdAt = firebase.firestore.FieldValue.serverTimestamp();
  await firebase
    .firestore()
    .collection('sellerMarketing201905')
    .doc()
    .set(payload);
};
